import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../../config/NaeSSchema";

class TripModel extends Model {
  static reducer(action, TripModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Trip.schema:
        action.payload.forEach((payload) => {
          const dbData = TripModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          TripModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
TripModel.modelName = "TripModel";

TripModel.fields = {
  id: attr(),
};

export default TripModel;